import { IMarketplaceFilterResponseValue } from 'src/typings/marketplace';

export const getMinAndMaxValues = (values: IMarketplaceFilterResponseValue[]): {min: number, max: number} => {
  const valuesArr = values.map((item) => Number(item.value));
  const min = Math.min(...valuesArr);
  const max = Math.max(...valuesArr);
  return { min, max };
};
